import { memo, ReactNode } from "react";
import { SubmitHandler } from "react-hook-form";
import { useSwipeable } from "react-swipeable";

type SwipeableProps = {
  readonly children: Array<ReactNode>;
  readonly onSubmitNextRoute: SubmitHandler<any>;
  readonly onSubmitPrevRoute: SubmitHandler<any>;
};

export const Swipeable = memo<SwipeableProps>(
  ({ children, onSubmitNextRoute, onSubmitPrevRoute }) => {
    const handlers = useSwipeable({
      onSwipedLeft: onSubmitNextRoute,
      onSwipedRight: onSubmitPrevRoute,
      delta: 70,
    });

    return <main {...handlers}>{children}</main>;
  }
);
